"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProductGallery = /** @class */ (function () {
    function ProductGallery() {
        this.$owl = $('.product-gallery__images');
        this.$thumbnails = $('.product-gallery__thumbs');
        this.$thumbnailsList = $('.product-gallery__thumb');
        this.$wrapper = $('#product-slider-wrapper > div');
        this.$thumbs = $(".product-gallery__thumbs");
        this.init();
    }
    ProductGallery.prototype.init = function () {
        this.carousel();
        this.eventListeners();
        this.$owl.trigger('refresh.owl.carousel');
        this.$thumbnails.trigger('refresh.owl.carousel');
        this.$wrapper.fadeIn(200);
    };
    ProductGallery.prototype.carousel = function () {
        this.$owl.owlCarousel({
            items: 1,
            slideSpeed: 2000,
            nav: false,
            autoplay: true,
            dots: false,
            loop: true,
            animateOut: 'fadeOut',
            mouseDrag: true,
            touchDrag: function () {
                return $('.product-gallery__images .product-gallery__image').length > 1;
            },
            URLhashListener: true,
            responsiveRefreshRate: 200,
            responsive: {
                768: {
                    nav: false
                }
            }
        });
        this.$thumbnails.owlCarousel({
            items: 3,
            slideSpeed: 2000,
            nav: true,
            autoplay: false,
            dots: false,
            loop: true,
            mouseDrag: false,
            URLhashListener: true,
            responsiveRefreshRate: 200,
            navText: [
                '<img src="/app/themes/tedee/assets/images/arrow-previous_org.svg" class="section__horizontal-slider-description__prev" alt="prev arrow">',
                '<img src="/app/themes/tedee/assets/images/arrow-next_org.svg" class="section__horizontal-slider-description__next" alt="next arrow">',
            ],
            responsive: {
                1300: {
                    items: 3,
                },
                992: {
                    items: 3,
                },
                991: {
                    items: 2,
                },
            },
        });
    };
    ProductGallery.prototype.eventListeners = function () {
        var _this = this;
        this.$owl.on('changed.owl.carousel', function (e) {
            var current = e.item.index;
            var imageHash = $(e.target).find(".owl-item").eq(current).find("img").attr('data-hash');
            _this.updateThumb(imageHash);
        });
        this.$thumbs.on("click", ".owl-item", function (e) {
            e.preventDefault();
            var number = $(e.target).find('a').attr('data-hash');
            var myString = parseInt(number.replace(/\D/g, ''));
            var calculated = myString - 1;
            console.log(myString);
            _this.$owl.trigger('to.owl.carousel', calculated);
        });
    };
    ProductGallery.prototype.updateThumb = function (imageHash) {
        this.$thumbnailsList.each(function () {
            var href = $(this).attr('href');
            var thumbHash = href.substr(1, href.length);
            if (thumbHash == imageHash) {
                if (!$(this).hasClass('cloned')) {
                    $(this).addClass('active');
                }
                return;
            }
            $(this).removeClass('active');
        });
    };
    return ProductGallery;
}());
exports.default = ProductGallery;
